// Angular
import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// RxJS
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../../core/reducers';
import { Permission, AuthService } from 'src/app/core/auth';
import { CommunicationsService } from '../../../../../../core/timeline/_services';
import { SharedHttpRequestService } from '../../../../../../core/lists';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { SalesTeam } from '../../../../../../core/timeline/_models/sales-team.model';

@Component({
  selector: 'kt-sales-team-edit-dialog',
  templateUrl: './sales-team-view-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SalesTeamViewDialogComponent implements OnInit, OnDestroy {
  // Public properties
  salesTeam: SalesTeam;
  salesTeam$: Observable<SalesTeam>;
  hasFormErrors = false;
  viewLoading = false;
  loadingAfterSubmit = false;
  allPermissions$: Observable<Permission[]>;
  salesTeamPermissions: Permission[] = [];

  private componentSubscriptions: Subscription;
  attachmentData = { communication_id: 0, type: '' };
  loadingTags = true;
  salesTeamTags = [];

  /**
   * Component constructor
   *
   * @param dialogRef: MatDialogRef<ViewDialogComponent>
   * @param data: any
   * @param store: Store<AppState>
   */
  constructor(
    public dialogRef: MatDialogRef<SalesTeamViewDialogComponent>,
    private auth: AuthService,
    private communicationsService: CommunicationsService,
    private sharedHttpRequestService: SharedHttpRequestService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.salesTeam = this.data.salesTeam;
    this.attachmentData = { communication_id: this.salesTeam.id, type: 'MEETING' };
    this.loadTags();
  }

  ngOnDestroy() {
    if (this.componentSubscriptions) {
      this.componentSubscriptions.unsubscribe();
    }
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.salesTeam.id, tagsViewContext.COMMUNICATION)
      .subscribe(
        (tags) => {
          this.salesTeamTags = tags.data;
          this.loadingTags = false;
        },
        () => {
          this.salesTeamTags = [];
          this.loadingTags = false;
        },
      );
  }

  // tslint:disable-next-line:variable-name
  getDate(from_time: string) {
    return new Date(from_time + ' GMT').toLocaleString();
  }
  estimateDuration(duration) {
    if (duration % 1 === 0 || duration % 1 === 0.5) {
      return duration + ' Hours';
    }
    return Math.floor(duration * 60) + ' Mins';
  }
}
